module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai84-2e299be080c946d484f2143f1071eb09.jpg";